import type { IconSvgObject } from './types';

const PieChart05Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 17L12 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 2L12 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PieChart05Icon;
